import { render, staticRenderFns } from "./SpaceDevicesList.vue?vue&type=template&id=71ef074c"
import script from "./SpaceDevicesList.vue?vue&type=script&lang=js"
export * from "./SpaceDevicesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports